module.exports = __webpack_public_path__ + "img/menu.7da7ed1d.svg";